import React, { useCallback } from 'react'
import { isWordFlowActive } from 'redux/slices/wordFlow'
import { start } from 'redux/slices/wordFlow/thunks'
import { useDispatch, useSelector } from 'react-redux'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import WordFlow from 'components/common/WordFlow/WordFlow'
import clsx from 'clsx'
import { useStyles } from './styles'

export const Poll: React.FC = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const isActive = useSelector(isWordFlowActive)

    const onStart = useCallback(() => dispatch(start()), [dispatch])

    return (
        <div className={clsx(classes.wrapper, !isActive && classes.notActiveWrapper)}>
            {(isActive && <WordFlow adminView durationModifier={0.5} minSpeed={0.5} />) || (
                <CallToActionButton
                    className={classes.startBtn}
                    display="block"
                    text="Start"
                    onClick={onStart}
                    type="secondary"
                />
            )}
        </div>
    )
}

export default React.memo(Poll)
